import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useCancelTreatmentReminder({
  patientId,
  consultationId,
}: {
  patientId: string
  consultationId?: string
}) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (reminderId: string) => {
      const response = await api.post('/treatment-reminders/:id/cancel', {
        params: { id: reminderId },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.reminder
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient-treatments', patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', patientId] })
      if (consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', consultationId] })
      }
    },
    // Surfaces the server message — e.g. the 409 when the reminder is no longer active
    // because another tab already cancelled it, or its shot was superseded.
    onError: (err) => {
      toast.error(err instanceof Error ? err.message : 'Failed to cancel reminder')
    },
  })
}
